var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRsjLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rsj-loader_svg__clip0_1645_4719)",
    fill: "#00809C"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.057,
    cy: 46.657,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 40.485,
    cy: 40.486,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 46.657,
    cy: 25.829,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 41.257,
    cy: 10.4,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 25.057,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 10.4,
    cy: 10.4,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 5,
    cy: 25.829,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 11.171,
    cy: 40.486,
    r: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rsj-loader_svg__clip0_1645_4719"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h52v52H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA1MiA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE2NDVfNDcxOSkiPgo8Y2lyY2xlIGN4PSIyNS4wNTcxIiBjeT0iNDYuNjU3MiIgcj0iNSIgZmlsbD0iIzAwODA5QyIvPgo8Y2lyY2xlIG9wYWNpdHk9IjAuOCIgY3g9IjQwLjQ4NTQiIGN5PSI0MC40ODU3IiByPSI1IiBmaWxsPSIjMDA4MDlDIi8+CjxjaXJjbGUgb3BhY2l0eT0iMC42IiBjeD0iNDYuNjU3MiIgY3k9IjI1LjgyODYiIHI9IjUiIGZpbGw9IiMwMDgwOUMiLz4KPGNpcmNsZSBvcGFjaXR5PSIwLjUiIGN4PSI0MS4yNTY4IiBjeT0iMTAuMzk5OSIgcj0iNSIgZmlsbD0iIzAwODA5QyIvPgo8Y2lyY2xlIG9wYWNpdHk9IjAuNCIgY3g9IjI1LjA1NzEiIGN5PSI1IiByPSI1IiBmaWxsPSIjMDA4MDlDIi8+CjxjaXJjbGUgb3BhY2l0eT0iMC4zIiBjeD0iMTAuNDAwNCIgY3k9IjEwLjM5OTkiIHI9IjUiIGZpbGw9IiMwMDgwOUMiLz4KPGNpcmNsZSBvcGFjaXR5PSIwLjIiIGN4PSI1IiBjeT0iMjUuODI4NiIgcj0iNSIgZmlsbD0iIzAwODA5QyIvPgo8Y2lyY2xlIG9wYWNpdHk9IjAuMSIgY3g9IjExLjE3MTQiIGN5PSI0MC40ODU3IiByPSI1IiBmaWxsPSIjMDA4MDlDIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTY0NV80NzE5Ij4KPHJlY3Qgd2lkdGg9IjUyIiBoZWlnaHQ9IjUyIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgRsjLoader as ReactComponent };